import drupalSettings from "./drupalSettings";

// Helper variables.
const minuteInMicrotime = 60000;
const HourInMicrotime = 3600000;

export const constructDate = (day, month, year) => {
  // Check for incomplete date
  if (!day || !month || !year) {
    return { invalid: false, incomplete: true };
  }

  const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
    monthLength[1] = 29;
  }

  // Check that day from date is valid
  if (day <= 0 || day > monthLength[month - 1]) {
    return { invalid: true, incomplete: false };
  }

  // Check that month from date is valid
  if (month < 1 || month > 12) {
    return { invalid: true, incomplete: false };
  }

  const yearStr = String(year);
  // Check that year from date is valid
  if (yearStr.length !== 4) {
    return { invalid: true, incomplete: false };
  }

  if (day && month && year) {
    // Convert browser time to UTC.
    const timezoneOffset = new Date().getTimezoneOffset() * minuteInMicrotime;
    // Note: Months are zero indexed.
    let date = new Date(new Date(year, month - 1, day) - timezoneOffset);
    const time = date.getUTCHours();

    // Hacky solution to daylight savings time. All dates should be at midnight.
    if (time === 23) {
      date = new Date(date.getTime() + HourInMicrotime);
    } else if (time === 1) {
      date = new Date(date.getTime() - HourInMicrotime);
    }

    if (date instanceof Date && !isNaN(date)) {
      return { invalid: false, incomplete: false, date };
    }
  }

  return { invalid: true, incomplete: false };
};

export const destructDate = dateString => {
  const dateObject = new Date(dateString);

  if (dateObject instanceof Date && !isNaN(dateObject)) {
    return {
      day: `0${dateObject.getDate()}`.slice(-2),
      month: `0${dateObject.getMonth() + 1}`.slice(-2),
      year: dateObject.getFullYear()
    };
  }

  return false;
};

export const formatDate = dateString => {
  const dateValues = destructDate(dateString);

  return `${dateValues.day}.${dateValues.month}.${dateValues.year}`;
};

export const calculateAge = dateString => {
  const dateObj = new Date(dateString);
  const ageDiff = Date.now() - dateObj.getTime();
  const ageDate = new Date(ageDiff);

  return Math.abs(ageDate.getUTCFullYear() - 1970);
};

export const isLegalDrinkingAge = dateString => {
  const country =
    localStorage.getItem("deliveryLocation") ||
    drupalSettings.regionMarket.market ||
    drupalSettings.regionMarket.location ||
    "GB";
  const ldas = drupalSettings.ed_dashboard.legal_drinking_ages;
  const ldaKeys = Object.keys(ldas);

  const defaultLda = parseInt(
    drupalSettings.ed_dashboard.default_legal_drinking_age,
    10
  );

  if (ldaKeys.indexOf(country) !== -1) {
    const lda = parseInt(ldas[country], 10);
    return calculateAge(dateString) >= lda;
  }

  return calculateAge(dateString) >= defaultLda;
};
